import { faker } from '@faker-js/faker';

const dateTime = '2024-06-07T00:00:00.000-03:00';

export const facematchKey = faker.string.uuid();

export const facematch = {
  key: facematchKey,
  document_type: 'rg',
  status: 'pending',
  under_review: false,
  evidences: [
    {
      captured_at: dateTime,
      kind: 'document_front',
      name: faker.system.commonFileName(),
      url: faker.image.avatar(),
    },
    {
      captured_at: dateTime,
      kind: 'document_back',
      name: faker.system.commonFileName(),
      url: faker.image.avatar(),
    },
    {
      captured_at: dateTime,
      kind: 'selfie',
      name: faker.system.commonFileName(),
      url: faker.image.avatar(),
    },
  ],
};

export const config = {
  async_checking: {
    quantity: 5,
    interval_in_seconds: 5,
  },
};

export const token = {
  token: faker.string.uuid(),
  environment: 'beta',
  token_expires_at: dateTime,
};
